module.exports = __webpack_public_path__ + "static/img/vipCard.3aa5ea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Menu/vipCard.png
// module id = K8vN
// module chunks = 0